import { render, staticRenderFns } from "./lading-page-cover.vue?vue&type=template&id=58ce43ba&scoped=true&"
import script from "./lading-page-cover.vue?vue&type=script&lang=js&"
export * from "./lading-page-cover.vue?vue&type=script&lang=js&"
import style0 from "./lading-page-cover.vue?vue&type=style&index=0&id=58ce43ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce43ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VParallax})
